import { render, staticRenderFns } from "./productPriceCell.vue?vue&type=template&id=21408498&scoped=true&"
import script from "./productPriceCell.vue?vue&type=script&lang=js&"
export * from "./productPriceCell.vue?vue&type=script&lang=js&"
import style0 from "./productPriceCell.vue?vue&type=style&index=0&id=21408498&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21408498",
  null
  
)

export default component.exports